import { useEffect, useState } from "react";
import { TagService } from "../../services/TagService";
import { useTranslation } from "react-i18next";

import TagListModal from "./TagListModal";
import TagGroupListModal from "./TagGroupListModal";

export default function TagOption({ interviewTag, setInterviewTag, editMode }) {
  const [tagGroup, setTagGroup] = useState([]);

  const [isOpenAddNewGroupModal, setIsOpenAddNewGroupModal] = useState(false);
  const [isTagListOpen, setIsTagListOpen] = useState(false);
  const [groups, setGroups] = useState([]);
  let { t } = useTranslation();
  
  useEffect(() => {
    TagService.getTags().then((data) => {
      setTagGroup(data);
      getGroups();
    });
  }, [isTagListOpen]);

  function getGroups() {
    TagService.getGroups().then((data) => {
      setGroups(data);
    });
  }

  const onTagClick = (event, tag) => {
    event.stopPropagation();

    let _interviewTagGroupIds = interviewTag.map(
      (tag) => tag.companyTagGroupId
    );
    let _interviewTags = [...interviewTag];
    if (event.target.checked) {
      if (tag.companyTagGroupId) {
        let index = _interviewTagGroupIds.indexOf(tag.companyTagGroupId);
        while (index > -1) {
          _interviewTagGroupIds.splice(index, 1);
          _interviewTags.splice(index, 1);
          index = _interviewTagGroupIds.indexOf(tag.companyTagGroupId);
        }
      }
      _interviewTags.push(tag);
    } else {
      let index = _interviewTags.map((x) => x.id).indexOf(tag.id);
      _interviewTags.splice(index, 1);
    }
    setInterviewTag(_interviewTags);
  };
  
  return (
    <>
      <li>
        <span
          id="tags"
          onClick={() => setIsTagListOpen(true)}
          class="dropdown-item-text"
        >
          {t("tags")} <i class="bi bi-gear"></i>
        </span>
      </li>
      <li>
        <span
          onClick={() => setIsOpenAddNewGroupModal(true)}
          class="dropdown-item-text"
        >
          {t("tag groups")} <i class="bi bi-gear"></i>
        </span>
      </li>
      <li>
        <hr class="dropdown-divider" />
      </li>
      {tagGroup.map((group) => {
        return (
          <>
            <li
              title={group.groupName}
              onClick={(event) => {
                event.stopPropagation();
              }}
            >
              <span class="dropdown-item-text">{group.groupName}</span>
            </li>

            {group.options.map((tag, index) => {
              return (
                <li
                  className="dropdown-item"
                  title={tag.description ?? tag.name}
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                >
                  <div class="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={tag.id}
                      name={group.groupName ?? tag.name}
                      checked={
                        interviewTag &&
                        interviewTag.some((t) => t.id === tag.id)
                      }
                      title={tag.description ?? tag.name}
                      onClick={(event) => onTagClick(event, tag)}
                      disabled={!editMode}
                    />
                    <label
                      className="form-check-label"
                      for={group.groupName ?? tag.name}
                    >
                      {tag.name}
                    </label>
                  </div>
                </li>
              );
            })}
            <li>
              <hr class="dropdown-divider" />
            </li>
          </>
        );
      })}

      <TagListModal
        isOpen={isTagListOpen}
        setIsOpen={setIsTagListOpen}
        closeModal={() => setIsTagListOpen(false)}
        groups={groups}
      />
      <TagGroupListModal
        isOpen={isOpenAddNewGroupModal}
        setIsOpenAddNewGroupModal={setIsOpenAddNewGroupModal}
        closeModal={() => {
          setIsOpenAddNewGroupModal(false);
          getGroups();
        }}
      />
    </>
  );
}
